<!--
 * @Author: DESKTOP-ROEB53E\caiyangjie 1760178806@qq.com
 * @Date: 2024-02-05 10:45:06
 * @LastEditors: DESKTOP-ROEB53E\caiyangjie 1760178806@qq.com
 * @LastEditTime: 2024-02-06 21:24:13
 * @FilePath: \vnlin\oms\src\view\order\ttForecastIfno\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
    :footer="footer"
    ref="table"
  >
  </cTable>
</template>

<script>
import cTable from "@/base/common/index";
import { apis } from "@/api/order/ttForecastInfo.js";
export default {
  name: "ttForecastInfo",
  components: {
    cTable
  },
  data() {
    return {
      methods: {
        ...apis
      },
      config: {},
      footer: {},
      modals: {},
      header: {
        searchs: [
          {
            key: "dateType",
            placeholder() {
              return this.$tz("时间,类型");
            },
            component: "Select",
            options: [],
            optionsFn: "",
            optionsKey: "TT_ORDER_SELECT"
          },
          {
            key: "startTime",
            placeholder() {
              return this.$tz("请选择,开始,日期");
            },
            component: "DatePicker",
            bind: {
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                }
              },
              style: {
                width: "150px"
              }
            }
          },
          {
            key: "endTime",
            placeholder() {
              return this.$tz("请选择,结束,日期");
            },
            component: "DatePicker",
            bind: {
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                }
              },
              style: {
                width: "150px"
              }
            }
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input",
            bind: {
              type: "textarea",
              autosize: { minRows: 2, maxRows: 2 }
            }
          }
        ],
        btns: {
          list: [
            {
              name: () => this.$tz('导出'),
              type: 'export',
              fnName: 'export',
              bind: {
                type: 'primary'
              },
              disabled(){
                return this.selectAll.length == 0
              }
            },
          ],
          methods: {
            export() {
              this.exportExc();
            }
          }
        }
      },
      fields: [
      {
          type: "checkbox",
          width: 50,
          fixed: "left",
          align: "center"
        },
        {
          name: () => this.$tz("订单号"),
          key: "airway_number",
          minWidth: 130
        },
        {
          name: () => this.$tz("城市"),
          key: "city",
          minWidth: 130
        },
        {
          name: () => this.$tz("地址,信息"),
          key: "address",
          minWidth: 130
        },
        {
          name: () => this.$tz("创建时间"),
          key: "create_time",
          minWidth: 130
        },
        {
          name: () => this.$tz("下单,时间"),
          key: "order_time",
          minWidth: 130
        },
        {
          name: () => this.$tz("到仓,时间"),
          key: "c_time",
          minWidth: 130
        }
      ]
    };
  }
};
</script>

<style scoped></style>
